<docs>
# Button

> NOTE: this docs defined at **docs** section inside Button.vue module

Button UI Set


<!-- STORY -->

### Example

>Type

```html
<mt-button>Default button</mt-button>
<mt-button type="primary">Primary button</mt-button>
<mt-button type="secondary">Secondary button</mt-button>
<mt-button type="secondary-gray">Secondary Gray button</mt-button>
<mt-button type="gradient">Gradient button</mt-button>
<mt-button type="subtle">Subtle button</mt-button>
```

>Size small

```html
<mt-button size="small">Small button</mt-button>
<mt-button type="primary" size="small">Small button</mt-button>
<mt-button type="secondary" size="small">Small button</mt-button>
<mt-button type="secondary-gray" size="small">Secondary Gray button</mt-button>
<mt-button type="gradient" size="small">Gradient button</mt-button>
<mt-button type="subtle" size="small">Small button</mt-button>
```

>Icon

```html
<mt-button size="small" icon="settings"></mt-button>
<mt-button size="small" icon="settings">설정하기</mt-button>
<mt-button size="small" type="primary" icon="settings">설정하기</mt-button>
<mt-button size="small" type="secondary" icon="settings">설정하기</mt-button>
<mt-button size="small" type="secondary-gray" icon="settings">설정하기</mt-button>
<mt-button size="small" icon="settings" type="subtle">Small button</mt-button>
```

>Disabled

```html
<mt-button disabled>Default button</mt-button>
<mt-button type="primary" disabled>Primary button</mt-button>
<mt-button type="secondary" disabled>Secondary button</mt-button>
<mt-button type="subtle" disabled>Subtle button</mt-button>
<mt-button size="small" disabled>Small button</mt-button>
<mt-button size="small" icon="settings" disabled>Small icon button</mt-button>
```

#### Props

| Property | Description      | Type     | Accepted Values           | Default     |
|----------|------------------|----------|---------------------------|-------------|
| type     | button type      | String   | default/primary/secondary/secondary-gray/gradient | default     |
| disabled | disable button   | Boolean  | —                         | false       |
| size     | button size      | String   | default/small             | default     |
| icon     | icon with button | String   | icon name of mt-icon      | —           |

</docs>
<template>
  <div class="button-wrap" @click="handleClick">
    <button
			type="button" class="mt-button"
			v-on:mouseover="hover = true" v-on:mouseleave="hover = false"
			:class="`mt-button--${type}` + (size == 'small' ? ' mt-button--small' : '') + (icon !== '' ? ' mt-button--icon' : '') + ( isOnlyIcon ? ' isOnlyIcon' : '') "
			:disabled="disabled"
		>
			<template v-if="icon">
				<mt-icon :iconName="icon" />
			</template>
			<span :class="{text: hasSlot}"><slot></slot></span>
		</button>
  </div>
</template>
<script>
import MtIcon from '../icon/Icon.vue'

export default {
  name: 'mt-button',
  props: {
		type: {
			type: String,
			default: 'default'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'default'
		},
		icon: {
			type: String,
			default: ''
		}
	},
	components: {
		MtIcon
	},
	provide () {
    let buttonStatus = {
			hoverColor: '#ffffff',
			size: this.size,
			color: this.type == 'primary' ? '#ffffff' : null
		}
		if(['subtle', 'secondary-gray'].includes(this.type)){
			buttonStatus.hoverColor = '#097DB7'
		}
    Object.defineProperty(buttonStatus, 'hover', {
       enumerable: true,
       get: () => this.hover,
    })
    Object.defineProperty(buttonStatus, 'color', {
       enumerable: true,
       get: () => {
         let result = null
         if(this.type == 'primary') result = '#ffffff'
         if(this.type == 'secondary') result = '#097DB7'
         if(this.disabled) result = '#B2C0D0'
         return result
       }
    })
    return { buttonStatus }
	},
	data() {
		return {
      hover: false,
      hasSlot: false
		}
  },
  computed : {
    isOnlyIcon() {
      let result = false
      if(!this.hasSlot && this.icon) result = true
      return result
    }
  },
	methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
  mounted () {
		let that = this
		setTimeout(function(){
			that.hasSlot = !!that.$slots['default']
		})
	},
}
</script>
<style src="./Button.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Button.vue?596a3e36